/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2022. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Client, SuperAdminUser } from '@truckstop-tms/zuum-lib';

import { createAction, props } from '@ngrx/store';

export const inviteUser = createAction(
  '[ClientDetails:Dashboard] Invite User',
  props<{ client: Client; users: SuperAdminUser[] }>()
);

export const deleteClient = createAction('[ClientDetails:Dashboard] Delete Client', props<{ clientId: number }>());
export const deleteClientSuccess = createAction(
  '[ClientDetails:Dashboard] Delete Client Success',
  props<{ clientId: number }>()
);
export const deleteClientFailure = createAction(
  '[ClientDetails:Dashboard] Delete Client Failure',
  props<{ errorMessage: string }>()
);
